define('MM/Components/ContentSearch/FacetHierarchyMultipleChoicePanel',[
    "jquery",
    "knockout",
    "underscore",
    "score_bootstrap/Utils/UrlHelper",
    "score_bootstrap/Models/SitecoreId",
    "MM/Models/ContentSearch/FacetDropdownViewModel",
    "MM/Models/ContentSearch/FacetHierarchyChoiceValue",
], function ($, ko, _, urlHelper, SitecoreId, FacetDropdownViewModel, FacetHierarchyChoiceValue) {
    "use strict";

    var searchLogic = ["and", "or_total_count", "or_incremental_count"];

    function FacetHierarchyMultipleChoicePanel(panelElement, allPreselected, urlParam) {
        var facetPanel = $(panelElement).data('facet');
        if (facetPanel != null) {
            // prevent assigning facet panel twice to the same element.
            return facetPanel;
        }
        Object.defineProperty(this, 'scope', { value: panelElement, enumerable: !0, configurable: !0, writable: !1 });

        var $dataEl = $(".js-facet", panelElement),
            title = $dataEl.data("title"),
            titleText = $dataEl.data("title-text"),
            searchLogicType = $dataEl.data("search-logic-type").toLowerCase(),
            preselectedValueByBackend = $dataEl.data("preselected-value"),
            preselectedByTitle = allPreselected[title] || preselectedValueByBackend || "",
            initialSelectedOptionText = $dataEl.data("placeholder"),
            facets = [];

        if (preselectedValueByBackend && !window.location.hash) {
            urlHelper.setHashValue(window.location, urlParam, title + ":" + preselectedValueByBackend);
        }


        var viewModel = new FacetDropdownViewModel(initialSelectedOptionText);
        viewModel.isAnySelected.subscribe(this._isAnySelectedHandler.bind(this));
        ko.applyBindings(viewModel, $dataEl.get(0));

        $(".js-row", panelElement).each(function () {
            var $el = $(this),
                id = $el.data("id"),
                val = $el.data("value"),
                text = $el.find('> label > .score-facet-value').text();
            facets.push(new FacetHierarchyChoiceValue(id, String(val), text, $el[0], (preselectedByTitle + '').split(',').some(function (value) { return value === (val + ''); }), $dataEl));
        });

        facets.forEach(function(facetItem){ facetItem._calculateSelectedRegions(); });

        $(".ipa-back", panelElement).on("click", function (e) {
            e.preventDefault();
            $(".score-button-menu", panelElement).removeClass("open");
        });

        Object.defineProperties(this, {
            title: { value: title },
            titleText: { value: titleText },
            searchLogicType: { value: searchLogic.indexOf(searchLogicType) },
            facets: { get: Array.prototype.slice.bind(facets) },
            asString: {
                get: function () {
                    var selectedFacets = facets.filter(function (facet) { return facet.selected(); });
                    var result = selectedFacets.map(function(facet) { return facet.value; }).join('|');
                    
                    if (!result) {
                        if (viewModel.selectedOptionText() !== initialSelectedOptionText) {
                            viewModel.selectedOptionText(initialSelectedOptionText);
                        }
                        viewModel.isAnySelected(false);
                        return null;
                    }

                    if (selectedFacets.length > 1) {
                        // filter top level facets
                        var topLevelFacets = selectedFacets.filter(function(facet) { return facet.scope.parentNode.closest('.js-row') == null; });
                        viewModel.selectedOptionText(topLevelFacets[0].text + (topLevelFacets.length > 1 ? ' (+' + (topLevelFacets.length -1) + ')' : ''));
                    } else if (selectedFacets.length === 1) {
                        viewModel.selectedOptionText(selectedFacets[0].text);
                    } else {
                        viewModel.selectedOptionText(result);
                    }
                    viewModel.isAnySelected(true);
                    return this.title + ":" + result;
                }
            }
        });

        this.selectValues = function(selectedValues) {
            var selectedByTitle = selectedValues[title] || "";
            facets.forEach(function (facet) {
                var oldValue = facet.selected();
                var newValue = selectedByTitle.indexOf(facet.value + '') > -1;
                if (oldValue !== newValue) {
                    facet.selected(selectedByTitle.indexOf(facet.value + '') > -1);
                }
            });
        };

        this.selectedValues = ko.pauseableComputed(function () {
            return _.filter(this.facets, function (val) {
                return val.selected();
            });
        }, this);

        this.unselectAll = function unselectAll() {
            this.selectedValues().forEach(function (value) {
                value.selected(false);
                value.selectedRegionsCount(0);
                value.selectedMarketsCount(0);
            });

            this.facets.forEach(function (facet) {
                facet.expanded(false);
            });

            viewModel.selectedOptionText(initialSelectedOptionText);
        };

        // Subscription to trigger from FacetMultipleChoiceValue which are always exist as a list options View Models in here. That's why without EventManager. 
        $dataEl.on("FacetHierarchyChoiceValue:disabled:checking", function () {
            this.updateBySelectedOption($dataEl, facets, initialSelectedOptionText, preselectedByTitle, this.titleText);
        }.bind(this));

        // When preselected value is from first level then need to preselect all second level as well
        this.selectedValues.pause();
        // loop by first level only
        [].forEach.call(panelElement.querySelectorAll('.panel-body > fieldset > .js-row'), function (el) {
            var isChecked = el.querySelector(':scope > input[type=checkbox]').checked;
            if (isChecked) {
                var childrenLevelEls = [].slice.call(el.querySelectorAll('.js-row'));
                if (childrenLevelEls.length > 0) {
                    var childrenLevelFacets = this.facets.filter(function(entity) {
                        if (childrenLevelEls.some(function(chEl) { return entity.scope.isEqualNode(chEl); })) {
                            return entity;
                        }
                    });
                    var selectedChildrenLevelFacets = childrenLevelFacets.filter(function (facet) { return facet.selected() === true });
                    // If we have preselected at least one children then no need to select all
                    if (selectedChildrenLevelFacets.length === 0) {
                        childrenLevelFacets.forEach(function (facetValue) { facetValue.selected(true); });
                    }
                }
            }
        }, this);
        this.selectedValues.resume();

        [].forEach.call(panelElement.querySelectorAll('.js-row'), function(el){
            el.addEventListener('levelSelectionChanged', this.propagateSelectionDeep.bind(this));
        }, this);

        // we have to subscribe to children event notifications later then the parent component, 
        // otherwise we will fail on recalculation of selection because the parent is responsible for that
        facets.forEach(function(facetItem){ 
            facetItem.subscribeToChildrenLevelSelectionChanged(); 
            facetItem._recalculatePartialSelection();
        });

        $(panelElement).data('facet', this);
    }

    FacetHierarchyMultipleChoicePanel.prototype.propagateSelectionDeep = function propagateSelectionDeep(e) {
        // pause notification to subscribers before batch update
        this.selectedValues.pause();

        // get children of the current facet value
        var childrenLevelEls = [].slice.call(e.target.querySelectorAll('.js-row'));

        // read current level checkbox state
        var state = e.target.querySelector(':scope > input[type=checkbox]').checked;
        if(childrenLevelEls.length > 0) {
            var facetToUpdate = this.facets.filter(function(entity) {
                // find facet values classes where we should propagate the state of the selection
                if(childrenLevelEls.some(function(el) { return entity.scope.isEqualNode(el); })) {
                    return entity;
                }
            });
            facetToUpdate.forEach(function(facetValue) {
                // update the selection state
                facetValue.selected(state);
                //facetValue.scope.querySelector(':scope > input').checked = state;
            })
            facetToUpdate.forEach(function(facetValue) {
                facetValue._recalculatePartialSelection();
            });
        }

        // if selection was true, then we should make sure all parents are selected as well
        for(var el = e.target; el && el !== document; el = el.parentNode) {
            // if state == true - we should propagate to the parent
            // if state == false - we should propagate to the parent only in case if parent -> children are NOT selected
            if(el.matches('.js-row') && (state || el.querySelector(':scope .js-row > input[type=checkbox]:checked') == null)) {
                // we should apply state change right away, because when we will move one level up, old selection will block us from doing correct calculations
                var facetToUpdate = this.facets.filter(function(entity) {
                    // find facet values classes where we should propagate the state of the selection
                    if(entity.scope.isEqualNode(el)) {
                        return entity;
                    }
                });
                facetToUpdate.forEach(function(facetValue) {
                    // update the selection state
                    facetValue.selected(state);
                })
                facetToUpdate.forEach(function(facetValue) {
                    facetValue._recalculatePartialSelection();
                });
            }
        }

        this.selectedValues.resume();
    }

    // It always reloads when I use viewModel.selectedOptionText() to update UI regarding selected and enabled list options based on retrieved from server side-data.
    // Made decision to implement this using jQuery.
    FacetHierarchyMultipleChoicePanel.prototype.updateBySelectedOption = function updateBySelectedOption($dataEl, facets, initialSelectedOptionText, preselectedByTitle, titleText) {
        var result = "";
        var cssClass = "is-any-selected";
        var isAnySelected = true;
        var selectedResult = facets.filter(function (el) { return el.selected() && !el.disabled(); });
        var preSelectedResult = preselectedByTitle ? facets.filter(function (el) { return el.value == preselectedByTitle[0]; }) : null;
        var selectedCount = selectedResult.length;
        
        if (selectedCount > 1) {
            // take just the top level options
            var topLevelFacets = selectedResult.filter(function(facet) { return facet.scope.parentNode.closest('.js-row') == null; });
            if(topLevelFacets.length > 0){
                result = topLevelFacets[0].text + (topLevelFacets.length > 1 ? ' (+' + (topLevelFacets.length -1) + ')' : '');
            }
        } else if (selectedCount === 1) {
            result = selectedResult[0].text;
        } else {
            if (preselectedByTitle && preSelectedResult) {
                result = preSelectedResult.text;
            }
            else {
                result = initialSelectedOptionText;
            }

            isAnySelected = false;
        }

        isAnySelected ? $dataEl.addClass(cssClass) : $dataEl.removeClass(cssClass);
        $dataEl.text(result);
    }

    FacetHierarchyMultipleChoicePanel.prototype._isAnySelectedHandler = function _isAnySelectedHandler(isSelected) {
        var btnEl = this.scope.querySelector('.score-button-menu > .score-button');
        // skip logic
        if (!btnEl) return;
        // define add/remove based on is there any selected item
        (isSelected 
            ? btnEl.classList.add('selection-complete') 
            : btnEl.classList.remove('selection-complete')
        );
    }

    return FacetHierarchyMultipleChoicePanel;
});
